import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ProductsService from "@services/ProductsService";

export const getCountries = createAsyncThunk(
  "product/countries",
  async (_, {rejectWithValue}) => {
    try {
      const response = await ProductsService.getCountries();

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getProductLine = createAsyncThunk(
  "product/product_line",
  async (_, {rejectWithValue}) => {
    try {
      const response = await ProductsService.getProductLine();

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getScenarios = createAsyncThunk(
  "product/scenarios",
  async (_, {rejectWithValue}) => {
    try {
      const response = await ProductsService.getScenarios();

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  scenarios: [],
  countries: [],
  productLine: [],
  errors: null,
  error: "",
  status: "",
};

const productOptionsSlice = createSlice({
  name: "product-options",
  initialState,
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearOptions() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.pending, (state) => {
        pendingState(state);
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.countries = action.payload;
        fulfilledState(state);
      })
      .addCase(getCountries.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getProductLine.pending, (state) => {
        pendingState(state);
      })
      .addCase(getProductLine.fulfilled, (state, action) => {
        state.productLine = action.payload;
        fulfilledState(state);
      })
      .addCase(getProductLine.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getScenarios.pending, (state) => {
        pendingState(state);
      })
      .addCase(getScenarios.fulfilled, (state, action) => {
        state.scenarios = action.payload;
        fulfilledState(state);
      })
      .addCase(getScenarios.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {setError, setStatus, clearOptions} = productOptionsSlice.actions;
export default productOptionsSlice.reducer;
